var _rect, _g, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 132,
    viewBox: "0 0 200 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_260_196545",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 200,
    height: 128
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 127.273,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_260_196545)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 113.121,
    width: 56.4528,
    height: 6.65346,
    fill: "url(#paint0_linear_260_196545)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 39.6746,
    y: 25.2031,
    width: 128.302,
    height: 98.2898,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_260_196545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.885 32.9493H41.2205V29.4356C41.2205 27.9574 42.4185 26.7578 43.8947 26.7578H162.203C163.679 26.7578 164.877 27.9574 164.877 29.4356V32.9493H164.885Z",
    fill: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.881,
    cy: 29.5283,
    rx: 1.75449,
    ry: 1.75683,
    fill: "#F42100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9994 27.7715C52.0332 27.7715 51.2449 28.5609 51.2449 29.5283C51.2449 30.4957 52.0332 31.2852 52.9994 31.2852C53.9655 31.2852 54.7538 30.4957 54.7538 29.5283C54.7616 28.5609 53.9732 27.7715 52.9994 27.7715Z",
    fill: "#20A200"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_260_196545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.858 119.761H45.2473C43.0213 119.761 41.2205 117.958 41.2205 115.729V32.3066H164.885V115.729C164.885 117.958 163.084 119.761 160.858 119.761Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.972 56.1367H136.287C134.803 56.1367 133.605 57.3363 133.605 58.8223V58.8919C133.605 60.3779 134.803 61.5775 136.287 61.5775H158.98C160.464 61.5775 161.662 60.3779 161.662 58.8919V58.8223C161.654 57.3363 160.456 56.1367 158.972 56.1367Z",
    fill: "#DADCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5378 36.5491H71.2707",
    stroke: "#A0A0A0",
    strokeWidth: 6.31848,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9963 48.2815H166.006",
    stroke: "#E0E0E0",
    strokeWidth: 1.0283,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5381 45.1545H58.9045",
    stroke: "#3C228A",
    strokeWidth: 3.79109,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4741 45.1545H77.8406",
    stroke: "#BCBCBC",
    strokeWidth: 3.79109,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.228 77.1799H166.23",
    stroke: "#E0E0E0",
    strokeWidth: 1.0283,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.762 74.053H59.1284",
    stroke: "#3C228A",
    strokeWidth: 2.52739,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9158 74.053H75.2822",
    stroke: "#BCBCBC",
    strokeWidth: 2.52739,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0693 74.053H91.4358",
    stroke: "#BCBCBC",
    strokeWidth: 2.52739,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2307 74.053H107.597",
    stroke: "#BCBCBC",
    strokeWidth: 2.52739,
    strokeLinecap: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123.361,
    y: 123.908,
    width: 34.8992,
    height: 7.48168,
    fill: "url(#paint1_linear_260_196545)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.063 107.154L142.291 111.44",
    stroke: "#3C228A",
    strokeWidth: 1.58824,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.947 102.537L147.197 106.847",
    stroke: "#3C228A",
    strokeWidth: 1.58824,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.351 88.3917C145.351 100.351 135.8 109.97 124.111 109.97C112.421 109.97 102.871 100.351 102.871 88.3917C102.871 76.4329 112.421 66.8132 124.111 66.8132C135.8 66.8132 145.351 76.4329 145.351 88.3917Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 6.35294
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.733 88.3917C147.733 101.635 137.147 112.353 124.111 112.353C111.075 112.353 100.488 101.635 100.488 88.3917C100.488 75.1482 111.075 64.4308 124.111 64.4308C137.147 64.4308 147.733 75.1482 147.733 88.3917Z",
    stroke: "#3C228A",
    strokeWidth: 1.58824
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.335 88.3916C142.335 98.6087 134.168 106.877 124.111 106.877C114.054 106.877 105.886 98.6087 105.886 88.3916C105.886 78.1746 114.054 69.9064 124.111 69.9064C134.168 69.9064 142.335 78.1746 142.335 88.3916Z",
    fill: "#3C228A",
    fillOpacity: 0.12,
    stroke: "#3C228A",
    strokeWidth: 1.22294
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.914 130.535L141.271 113.661L149.035 105.79L165.678 122.663L157.914 130.535Z",
    fill: "white",
    stroke: "#3C228A",
    strokeWidth: 1.58824
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 113.854L149.922 111.732",
    stroke: "#3C228A",
    strokeWidth: 1.58824,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.922 111.732L157.88 119.801",
    stroke: "#3C228A",
    strokeWidth: 1.58824,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_260_196545",
    transform: "scale(0.0060241 0.00787402)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_260_196545",
    x: 29.2205,
    y: 14.7578,
    width: 147.665,
    height: 30.1914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_260_196545"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_260_196545",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_260_196545",
    x: 29.2205,
    y: 20.3066,
    width: 147.665,
    height: 111.455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_260_196545"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_260_196545",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_260_196545",
    x1: 0,
    y1: 119.25,
    x2: 47.5547,
    y2: 119.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_260_196545",
    x1: 123.361,
    y1: 130.8,
    x2: 152.759,
    y2: 130.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDF"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_260_196545",
    width: 166,
    height: 127,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKYAAAB/CAYAAABlubmQAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAApqADAAQAAAABAAAAfwAAAAALfUYJAAAFA0lEQVR4Ae2XO2uUbQBEXTVGES8ooqiNYGNhJ9aC+7PXPyB2FhaCNl6RiBFEzdWZzb6aDVsMuO9U54Fxk80k83G+w/Mmk1PHzmw2myw+HV6PfZUPITAagUP/5Ol0On/1x38FlJSn9fmGsrl4/fs1fc6BwFgELOOu8tuvkvPAQ3P5FlJe0Oc3lDvKVeWsgpyCwBmNgKXcU74p75Uvyk/LOVk8vs/pjdvKI+Wxclc5r3AgMDaBXxp4pzxXXigflB3fij5+fPumtJRPFEtqWTkQGJvAjgYso89HZUuZi+nHtX+3vKL4prSUfqSfUTgQGJvA/mLA7tlBuzgZbsxBTt+cviktpf8Y4kCgQcDOLf3RfVI+/thp/G9gYxWBJfdOirnqG3gPAnUCiFlHzmBCADETSnTqBBCzjpzBhABiJpTo1AkgZh05gwkBxEwo0akTQMw6cgYTAoiZUKJTJ4CYdeQMJgQQM6FEp04AMevIGUwIIGZCiU6dAGLWkTOYEEDMhBKdOgHErCNnMCGAmAklOnUCiFlHzmBCADETSnTqBBCzjpzBhABiJpTo1AkgZh05gwkBxEwo0akTQMw6cgYTAoiZUKJTJ4CYdeQMJgQQM6FEp04AMevIGUwIIGZCiU6dAGLWkTOYEEDMhBKdOgHErCNnMCGAmAklOnUCiFlHzmBCADETSnTqBBCzjpzBhABiJpTo1AkgZh05gwkBxEwo0akTQMw6cgYTAoiZUKJTJ4CYdeQMJgQQM6FEp04AMevIGUwIIGZCiU6dAGLWkTOYEEDMhBKdOgHErCNnMCGAmAklOnUCiFlHzmBCADETSnTqBBCzjpzBhABiJpTo1AkgZh05gwkBxEwo0akTQMw6cgYTAoiZUKJTJ4CYdeQMJgQQM6FEp04AMevIGUwIIGZCiU6dAGLWkTOYEEDMhBKdOgHErCNnMCGAmAklOnUCiFlHzmBCADETSnTqBBCzjpzBhABiJpTo1AkgZh05gwkBxEwo0akTQMw6cgYTAoiZUKJTJ4CYdeQMJgQQM6FEp04AMevIGUwIIGZCiU6dAGLWkTOYEEDMhBKdOgHErCNnMCGAmAklOnUCiFlHzmBCADETSnTqBBCzjpzBhABiJpTo1AkgZh05gwkBxEwo0akTQMw6cgYTAoiZUKJTJ4CYdeQMJgQQM6FEp04AMevIGUwIIGZCiU6dAGLWkTOYEEDMhBKdOgHErCNnMCGAmAklOnUCiFlHzmBCADETSnTqBBCzjpzBhABiJpTo1AkgZh05gwkBxEwo0akTQMw6cgYTAoiZUKJTJ4CYdeQMJgQQM6FEp04AMevIGUwIIGZCiU6dAGLWkTOYEDgp5mHyTXQgMAKBJfcGMf3mrrKzeF0qjfAfwY+EwEBgpXsWc/jCd338WdlWLChyCgJnVAJ2zK7ZObtnB31BHp7VPz6/lU/KK+W+ckm5ppxTJgoHAusmMEj5VT/4jWL37KBdPJJuNpud0cdXlIfKU+WRck/xexsKBwLrJuCb0TflW+WF8kx5qWxPp9P94cY80Bs/lNeKzwflgXJT2VQ4EFg3Ad+Mfnz7pnTsnh20i/8e07o1/fumb8eLynXllnJZsbw8zgWBszYCfozvKf6d0o/vLcVS7uq2XBZTb56SnBbQglpG35QWFSkFgbN2ApbTj3PfnJb0QFL6vflZKd1CUBdWfv3oW/kXAv9NYC7icSGHn/gHfQJ4igyGeM4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.4e4e9735eebb701a0d02f8d4ef833120.svg";
export { ForwardRef as ReactComponent };